import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AttrPath, UitstroomtypeVSO } from '@cumlaude/metadata';
import { BasicFilterExpression, FilterExpression } from '../../services/data.service';
import { UitzonderingPrestatieanalyseComponent } from './uitzondering-prestatieanalyse.component';
import { BarchartTableComponent } from '../../shared/dashboard/barchart-table/barchart-table.component';
import { SchooljaarIndicatorOverComponent } from '../../schooljaar-indicator-over/schooljaar-indicator-over.component';
import { TooltipDirective } from '@cumlaude/shared-components-overlays';
import { DashboardHeaderComponent } from '../../dashboard-header/dashboard-header.component';
import { FilterPanelComponent } from '../../filter-panel/filter-panel.component';
import { DashboardContainerComponent } from '../../layout/dashboard-container/dashboard-container.component';
import { FilterBarComponent } from '../../filter-bar/filter-bar.component';
import { IconComponent } from '@cumlaude/shared-components-icons';
import { FilterName } from '../../services/filter-name';

@Component({
	selector: 'app-uitzondering-tussentijdse-uitstroom',
	templateUrl: './uitzondering.component.html',
	styleUrls: ['./uitzondering.component.scss'],
	imports: [
		DashboardContainerComponent,
		FilterPanelComponent,
		DashboardHeaderComponent,
		TooltipDirective,
		SchooljaarIndicatorOverComponent,
		BarchartTableComponent,
		FilterBarComponent,
		IconComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UitzonderingTussentijdseUitstroomComponent extends UitzonderingPrestatieanalyseComponent {
	override fixedBeforeGroups = 4;

	groups: AttrPath[] = [
		['ds_nm_prestatieanalyse_vso_uitzondering'],
		['ds_nm_tussentijdse_uitstroom_vso_status'],
		['ds_fk_ll', 'll_nm_schoolsoort_svb'],
		['ds_fk_ll', 'll_des_uitschrijving'],
	];
	override overrideDefault?: Partial<{ [name in FilterName]: any }> = { ds_nm_tussentijdse_uitstroom_vso: [null] };

	initialFilters: FilterName[] = [
		'x_prestatieanalyse_ds_schooljaar',
		'ds_fk_br_vest_van.br_co_brin',
		'ds_fk_ilt_van.ilt_nm_niveau',
		'ds_nr_leerjaar_van',
		'ds_nm_prestatieanalyse_vso_uitzondering',
		'ds_nm_tussentijdse_uitstroom_vso_status',
		'ds_nm_tussentijdse_uitstroom_vso',
	];

	permanentFilterExpressions: FilterExpression[] = [
		new BasicFilterExpression(['ds_is_plaatsing_opeenvolgend'], 1), // Voorkom dubbelingen maar sta wel tussentijdse in/uitstroom toe
		new BasicFilterExpression(['ds_nm_uitstroomtype_vso'], UitstroomtypeVSO.TUSSENTIJDSE_UITSTROOM),
		new BasicFilterExpression(['ds_fk_br_vest_van', 'br_is_vso'], 1),
	];
}
